// extracted by mini-css-extract-plugin
export var blockDecoration = "index-module--blockDecoration--e7N4P";
export var industry = "index-module--industry--bXQ3W";
export var industryContent = "index-module--industryContent--7wAGj";
export var industryImage = "index-module--industryImage--6Oeq4";
export var industryText = "index-module--industryText---OydE";
export var industryTitle = "index-module--industryTitle--4tjdw";
export var industryTitleList = "index-module--industryTitleList--K9vF7";
export var more = "index-module--more--pTQ+W";
export var p1 = "index-module--p1--MoAvb";